import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { GET_TOKEN } from 'dealer-reducers'
import Spinner from '../atoms/Spinner'

const Callback = (): JSX.Element => {
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()

  useEffect(() => {
    const code = searchParams.get('code')
    if (code !== null && code !== '') {
      dispatch(GET_TOKEN({ code }))
    }
  }, [searchParams, dispatch])

  return <Spinner />
}

export default Callback
